import React from 'react';
import PropTypes from 'prop-types';

function MastercardCardIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="24"
      viewBox="0 0 34 24"
      className={className}
    >
      <g fill="none" fillRule="evenodd">
        <rect width="33" height="23" x=".5" y=".5" fill="#FFF" stroke="#E1E1E1" rx="3" />
        <path fill="#EB982E" d="M27 12a6 6 0 11-12 0 6 6 0 0112 0" />
        <path fill="#D5232A" d="M13 18a6 6 0 110-12 6 6 0 010 12z" />
        <path
          fill="#DF5929"
          d="M17 16.47A5.99 5.99 0 0115 12c0-1.78.77-3.37 2-4.47A5.99 5.99 0 0119 12a5.99 5.99 0 01-2 4.47z"
        />
      </g>
    </svg>
  );
}

MastercardCardIcon.propTypes = {
  className: PropTypes.string,
};

export default MastercardCardIcon;
